import axios from "axios";
import { BASE_URL, API_ENDPOINTS } from "./apiEndpoints";

const axiosConfig = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-Type": "application/json",
    "Accept": "application/json",
  },

});

const excludeEndpoints = [
  API_ENDPOINTS.LOGIN,
  API_ENDPOINTS.REGISTER,
  API_ENDPOINTS.REFRESH_TOKEN,
  API_ENDPOINTS.VALIDATE_TENANT,
];



axiosConfig.interceptors.request.use(
  (config) => {
    const url = config.url || "";

    const shouldSkipToken = excludeEndpoints.some((endpoint) =>
      url.startsWith(endpoint)
    );

    if (!shouldSkipToken) {
      const accessToken = localStorage.getItem("token");
      if (accessToken) {
        config.headers["Authorization"] = `Bearer ${accessToken}`;
      }
    }

    return config;
  },
  (error) => Promise.reject(error)
);

axiosConfig.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const status = error.response.status;
      const url = error.config?.url || "";

      if (status === 401 || status === 403) {
        if (url.startsWith("/api/subdomain/validate")) {
         //window.location.href = "/unauthorized";
        } else {
          // window.location.href = "/";
        }
      } else if (status === 500) {
        console.error("Server error:", error.response.data);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosConfig;